/*
 * This file is auto-generated by ./bin/rails stimulus:manifest:update
 * Run that command whenever you add a new controller or create them with
 * ./bin/rails generate stimulus controllerName
 */

import {application} from "./application";

import AutoAdvanceController from "./auto_advance_controller";
application.register("auto-advance", AutoAdvanceController);

import TextSizeController from "./text_size_controller";
application.register("text-size", TextSizeController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import ConfirmDialogController from "./confirm_dialog_controller";
application.register("confirm-dialog", ConfirmDialogController);

import DeckTypeController from "./deck_type_controller";
application.register("deck-type", DeckTypeController);

import DialogController from "./dialog_controller";
application.register("dialog", DialogController);

import DisclosureController from "./disclosure_controller";
application.register("disclosure", DisclosureController);

import FileUploadController from "./file_upload_controller";
application.register("file-upload", FileUploadController);

import FontController from "./font_controller";
application.register("font", FontController);

import FuzzyFindController from "./fuzzy_find_controller";
application.register("fuzzy-find", FuzzyFindController);

import HotkeysController from "./hotkeys_controller";
application.register("hotkeys", HotkeysController);

import MissController from "./miss_controller";
application.register("miss", MissController);

import MobileNavController from "./mobile_nav_controller";
application.register("mobile-nav", MobileNavController);

import MusicStudyController from "./music_study_controller";
application.register("music-study", MusicStudyController);

import RailController from "./rail_controller";
application.register("rail", RailController);

import TimezoneController from "./timezone_controller";
application.register("timezone", TimezoneController);

import WakeLockController from "./wake_lock_controller";
application.register("wake-lock", WakeLockController);

import WordStatesController from "./word_states_controller";
application.register("word-states", WordStatesController);
